import React from 'react';
import { Button } from 'carbon-components-react';
import { ArrowUp16, ArrowRight16 } from '@carbon/icons-react';
import { SCREEN_SIZE } from 'types';

export const AboutAndADS: React.FC<Props | any> = (props: Props) => {
  const {
    goToTop,
    screenSize,
    handleGetPlansClick,
    referrals,
    handleCLOOpenModal,
    handleOnClickISPLink
  } = props;

  return (
    <>
      <div className="about-and-ads">
        <div className="about">
          <div className="about-content">
            <div className="about-content-title">About responses and plans</div>
            <div className="about-content-message">
              Plans are indicative only and property connections may not be
              shown. All assets may not be included in the response provided.
              You can engage a skilled locator to assist with the location of
              assets. Check your spam/junk folders for missing responses. Please
              follow safe excavation advice.
            </div>
          </div>
        </div>

        <div className="ad">
          <div className="ad-content">
            <div className="ad-content-title">
              Certified Locating Organisations <span>(CLOs)</span>
            </div>
            <div className="ad-content-message">
              Underground infrastructure networks are complex and require expert
              knowledge to identify the location of buried services carefully
              and safely. To reduce the risk of accidental damage or workplace
              injury, we highly recommend the services of a Certified Locator.
              The Certified Locator program is owned and operated by CERTLOC
              Global.
              <div className="ad-content-message-links">
                <div
                  className="ad-content-message-link"
                  onClick={handleCLOOpenModal}
                >
                  CLOs servicing this area
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="ad">
          <div className="ad-content">
            <div className="ad-content-title">
              Find trusted contractors and equipment fast
            </div>
            <div className="ad-content-message">
              Finding trusted contractors and quality equipment is crucial for a
              safe and successful project. Use the FREE iseekplant construction
              services marketplace–backed by BYDA and trusted by 1,000s of
              construction professionals everyday. Fast, free and easy to
              use–simply request a quote today.
              <div
                className="ad-content-message-link"
                onClick={() => handleOnClickISPLink()}
              >
                Get equipment and contractor quotes today
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bottom-menu">
        <div className="bottom-menu-top-button">
          {screenSize !== SCREEN_SIZE.SM ? (
            <Button
              kind={'ghost'}
              renderIcon={ArrowUp16}
              onClick={goToTop}
              iconDescription="Go to top"
            >
              TOP
            </Button>
          ) : (
            <Button
              kind={'tertiary'}
              renderIcon={ArrowUp16}
              iconDescription="Go to top"
              onClick={goToTop}
              hasIconOnly
            />
          )}
        </div>
        <div className="bottom-menu-get-plans-button">
          {referrals && (
            <Button
              renderIcon={ArrowRight16}
              onClick={handleGetPlansClick}
              iconDescription="View responses"
            >
              View responses
            </Button>
          )}
        </div>
      </div>
    </>
  );
};

type ownProps = {
  goToTop: any;
  screenSize: String;
  enquiryDetail: any;
  handleGetPlansClick: Function;
  referrals: any;
  handleCLOOpenModal: any;
  handleOnClickISPLink: Function;
};

type Props = ownProps;

AboutAndADS.displayName = 'AboutAndADS';

export default React.memo(AboutAndADS);
